import {
  CREATEENQUIRY,
  DELETEENQUIRY,
  GETENQUIRY,
  GETENQUIRYBYID,
  UPDATEENQUIRY,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEENQUIRY:
      return {
        ...state,
        enquirySaveStatus: action.payload.success,
      };
    case GETENQUIRY:
      return {
        ...state,
        enquiryList: action.payload.data,
      };
    case GETENQUIRYBYID:
      return {
        ...state,
        enquiryDetail: action.payload.data,
      };
    case UPDATEENQUIRY:
      return {
        ...state,
        enquiryUpdateStatus: action.payload.success,
      };
    case DELETEENQUIRY:
      return {
        ...state,
        enquiryDeleteStatus: action.payload.success,
      };
    default:
      return state;
  }
}